// extracted by mini-css-extract-plugin
export default {"leftPopoverTitle":"companyIntro_leftPopoverTitle__4ZMfk","leftPopoverContent":"companyIntro_leftPopoverContent__ye7jn"};